export default {
    root: {
        backgroundColor: '#DEDEDE',
    }
  };
  